import { AppLayout, ManagedFundHero, SectorOverview } from '@components'
import { Mixpanel } from '@utils'
import type { NextPage } from 'next'
import { NextSeo } from 'next-seo'
import Link from 'next/link'

const ManagedFund: NextPage = () => {
  return (
    <AppLayout>
      <NextSeo
        title="MarketX Ventures - Private Equity Investment Management Platform"
        description="MarketX Ventures is a one-stop shop for over 300 family offices, funds, and
        high net worth individuals to access high growth investment
        opportunities."
      />
      <ManagedFundHero />

      <div className="bg-[#4e2780]">
        <div className="container mx-auto px-5 py-[105px] lg:px-[348px]">
          <h1 className="leading-12 text-center text-[21px] font-semibold text-white lg:text-[38px]">
            Invest Alongside the Top VCs in
            <br />
            <span className="border-b-4 border-[#8ce6d7]">
              Exclusive Opportunities
            </span>
          </h1>
          <p className="px-0 pt-7 text-center text-lg text-white md:px-24 lg:px-16 2xl:px-44">
            Our strategy offers significant upside potential and access to
            investments that have been backed by the top 1% of Global VC funds.
          </p>
        </div>
      </div>

      <SectorOverview />

      <div className="bg-[#4e2780] py-20">
        <div className="container mx-auto flex flex-col items-center justify-between px-5 md:flex-row lg:items-start lg:px-44">
          <h4 className="w-11/12 text-[22px] font-light leading-7 text-white lg:w-[70%] 2xl:w-7/12">
            Join the private world of global growth-stage and pre-IPO investing
            while generating high returns and producing social impact
          </h4>
          <button
            className="mt-5 w-5/12 rounded-lg border border-white py-4 text-[10px] font-semibold uppercase tracking-[1px] 
          text-white transition delay-150 duration-100 ease-in-out hover:bg-white hover:text-[#4364e8] md:text-xs lg:mt-1 lg:w-1/5">
            <Link
              href={process.env.NEXT_PUBLIC_DEFAULT_CALENDLY_URL!}
              target="_blank"
              rel="noreferrer"
              onClick={() => Mixpanel.track('fund.invest-now')}>
              Invest Now
            </Link>
          </button>
        </div>
      </div>
    </AppLayout>
  )
}

export default ManagedFund
